export const MOBILE_CENTERED_SHELL_PORTAL_ROOT_ID =
  "mobile-centered-shell-portal-root";

export const getMobileCenteredShellPortalRoot = () => {
  if (typeof document === "undefined") {
    return null;
  }

  return document.getElementById(MOBILE_CENTERED_SHELL_PORTAL_ROOT_ID);
};

export type ShellSafePopupContainerResolver = (
  triggerNode?: HTMLElement | null
) => Element;

export const getShellSafePopupContainer = (
  triggerNode?: HTMLElement | null,
  localFallback?: Element | null
): Element => {
  const shellPortalRoot = getMobileCenteredShellPortalRoot();
  if (shellPortalRoot) {
    return shellPortalRoot;
  }

  if (localFallback) {
    return localFallback;
  }

  if (triggerNode?.parentElement) {
    return triggerNode.parentElement;
  }

  if (triggerNode) {
    return triggerNode;
  }

  return document.body;
};

export const withShellSafePopupContainer = (
  getPopupContainer?: ShellSafePopupContainerResolver,
  localFallback?: Element | null
): ShellSafePopupContainerResolver => {
  if (getPopupContainer) {
    return getPopupContainer;
  }

  return (triggerNode?: HTMLElement | null) =>
    getShellSafePopupContainer(triggerNode, localFallback);
};
